export const WORK_ORDER_STATUSES = ['draft', 'open', 'in_progress', 'completed', 'cancelled'] as const;

export type WorkOrderStatus = (typeof WORK_ORDER_STATUSES)[number];

export const workOrderStatusLabel: Record<WorkOrderStatus, string> = {
  draft: 'Draft',
  open: 'Terbuka',
  in_progress: 'Berjalan',
  completed: 'Selesai',
  cancelled: 'Dibatalkan',
};

export const workOrderStatusDescription: Record<WorkOrderStatus, string> = {
  draft: 'Work order baru dibuat. Checklist peralatan belum lengkap.',
  open: 'Checklist peralatan sudah lengkap. Siap dikerjakan petugas sampling.',
  in_progress: 'Petugas sampling sudah mulai survey di lapangan.',
  completed: 'Sampel sudah diterima. Work order selesai.',
  cancelled: 'Work order dibatalkan dan tidak dilanjutkan.',
};

export function workOrderStatusDisplay(status: string | null | undefined): string {
  if (!status) return '—';
  return workOrderStatusLabel[status as WorkOrderStatus] ?? status;
}

export function workOrderStatusTooltip(status: string | null | undefined): string {
  if (!status) return '';
  return workOrderStatusDescription[status as WorkOrderStatus] ?? '';
}

/** ISO datetime → value untuk input `datetime-local`. */
export function isoToDatetimeLocal(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function testingDatesFromSamplingSchedule(schedule?: {
  customer_agreed_start_date?: string | null;
  customer_agreed_end_date?: string | null;
} | null): { start: string; end: string } {
  return {
    start: isoToDatetimeLocal(schedule?.customer_agreed_start_date),
    end: isoToDatetimeLocal(schedule?.customer_agreed_end_date),
  };
}

export const WORK_ORDER_TESTING_DATES_HELPER =
  'Diisi otomatis dari rentang jadwal penjadwalan sampling. Ubah tanggal di halaman penjadwalan, bukan di work order.';
